import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { ErrorBoundary } from 'bernie-view';
import { LocalizedComponentProps } from 'bernie-l10n';

import { useLocalization } from '@shared-ui/localization-context';

import { BadgeModel, PriceViewModel } from 'models/common';
import { RecentlyViewedModel } from 'models';

import { BadgeGenerator } from 'components/common/badge-generation';
import { Price } from 'components/common/pricing/price';
import { PriceLockup } from 'components/common/pricing/price-lockup';

export interface PriceAndSupportingMessagesContainerProps extends LocalizedComponentProps {
  index?: number;
  secondaryCardMessage?: string;
  price?: PriceViewModel;
  supportingMessages?: string[];
  viewSmall: boolean;
  wrapPrice: boolean;
  priceFontWeight: string;
  hotelId?: number;
  secondary?: BadgeModel;
  recentlyViewed?: RecentlyViewedModel;
  isDatelessPdp?: boolean;
  infositeUrl?: string;
  history?: {
    push: (submitUrl: string) => void;
  };
}

export const PriceAndSupportingMessagesContainer: React.FunctionComponent<PriceAndSupportingMessagesContainerProps> = ({
  index,
  secondaryCardMessage,
  supportingMessages,
  price,
  viewSmall,
  wrapPrice,
  priceFontWeight,
  hotelId,
  secondary,
  recentlyViewed,
  isDatelessPdp,
  infositeUrl,
}) => {
  const l10n = useLocalization();

  const priceCommonProps = {
    index,
    price,
    hotelId,
    priceFontWeight,
    recentlyViewed,
    messages: supportingMessages,
  };

  const priceLockupProps = {
    price,
    uniqueId: hotelId,
    supportingMessages,
    infositeUrl,
    stids: {
      lockupId: 'display-price',
      strikeThroughId: 'strikeout-price',
      subtextFirstId: 'price-messages',
      subtextStandardId: 'supporting-messages',
    },
    l10n,
  };

  if (isDatelessPdp) {
    return null;
  }
  if (viewSmall) {
    return (
      <div className="uitk-cell all-x-gutter-two uitk-type-right all-cell-shrink listing__pricing s-t-padding-half">
        {secondaryCardMessage && (
          <span className="secondary-card-message uitk-type-200 uitk-type-medium pwa-theme--grey-900">{secondaryCardMessage}</span>
        )}
        <AbacusExperiment name="SRP_UITK_PriceLockup_Migration">
          <AbacusControl>
            <ErrorBoundary label="hotel.search.listing.price">
              <Price className="listing__price" wrapPrice={wrapPrice} {...priceCommonProps} />
            </ErrorBoundary>
          </AbacusControl>
          <AbacusVariant bucket={1}>
            <ErrorBoundary label="hotel.search.listing.priceLockup">
              <PriceLockup {...priceLockupProps} />
            </ErrorBoundary>
          </AbacusVariant>
        </AbacusExperiment>
      </div>
    );
  }

  return (
    <div className="uitk-cell all-x-gutter-two uitk-type-right all-cell-shrink">
      {secondary && (secondary.text || secondary.icon) && <BadgeGenerator badge={secondary} />}
      {secondaryCardMessage && (
        <div className="secondary-card-message uitk-type-200 uitk-type-medium pwa-theme--grey-900 all-t-margin-one">
          {secondaryCardMessage}
        </div>
      )}{' '}
      <AbacusExperiment name="SRP_UITK_PriceLockup_Migration">
        <AbacusControl>
          <ErrorBoundary label="hotel.search.listing.price">
            <Price className="listing__price all-t-padding-half" {...priceCommonProps} />
          </ErrorBoundary>
        </AbacusControl>
        <AbacusVariant bucket={1}>
          <ErrorBoundary label="hotel.search.listing.priceLockup">
            <PriceLockup {...priceLockupProps} />
          </ErrorBoundary>
        </AbacusVariant>
      </AbacusExperiment>
    </div>
  );
};
